import axios, { AxiosResponse } from 'axios';
import { addParam, splitParams } from '../../../utils/servicesHelper';
import {
  SampleAssessmentExamTaskGroupSolutionIdsResponseWithSchoolCode,
  SampleAssessmentList,
  SampleAssessmentRGZList,
} from './examTaskGroupSolution.types';
import EnvWindow from '../../../utils/env';

export async function getSampleAssessmentSolution(
  signal?: AbortSignal,
  pageSize = 0,
  pageNumber = 20,
  committee?: string,
  schoolCode?: string,
  countFrom?: string,
  countTo?: string,
): Promise<AxiosResponse<SampleAssessmentList>> {
  let params = '';
  params += addParam('schoolCode', schoolCode ? schoolCode : '');
  params += splitParams('committee', committee) ?? '';
  params += addParam('countFrom', countFrom ? countFrom : '');
  params += addParam('countTo', countTo ? countTo : '');
  return await axios.get(
    `${EnvWindow.REACT_APP_SCANS_URL}/ExamTaskGroupSolution/School?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
    {
      signal: signal ?? undefined,
    },
  );
}

export async function getSampleAssessmentSolutionRGZ(
  schoolId: string,
  signal?: AbortSignal,
  pageSize = 20,
  pageNumber = 0,
  examineeIdentity?: string,
  examTaskGroupSolutionId?: string,
  assigmentState?: string,
): Promise<AxiosResponse<SampleAssessmentRGZList>> {
  const assignmentState = assigmentState ? assigmentState.split(',') : [];
  const paramAssigmentState = assignmentState.map((a) => addParam('assignmentState', a)).join('');

  let params = '';
  params += addParam('examineeIdentity', examineeIdentity ? examineeIdentity : '');
  params += addParam('examTaskGroupSolutionId', examTaskGroupSolutionId ? examTaskGroupSolutionId : '');
  params += paramAssigmentState.length ? paramAssigmentState : '';
  return await axios.get(
    `${EnvWindow.REACT_APP_SCANS_URL}/ExamTaskGroupSolution/School/${schoolId}?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
    {
      signal: signal ?? undefined,
    },
  );
}

export async function getExamTaskGroupSolutionIds(
  schoolId: string,
): Promise<SampleAssessmentExamTaskGroupSolutionIdsResponseWithSchoolCode> {
  const response = await axios.get(`${EnvWindow.REACT_APP_SCANS_URL}/ExamTaskGroupSolution/School/${schoolId}/ids`);
  return response.data;
}
